import './bootstrap';
import '../../vendor/masmerise/livewire-toaster/resources/js';
import './template-creator';
import './comments-composer';
import './video-players';
import docsSearch from './docs-search';
import videoReviewPlayer from './video-review-player';
import SignaturePad from 'signature_pad';

import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
import TomSelect from 'tom-select';

// import './libs//trix';
import ui from '@alpinejs/ui';
// intersect is already included in Livewire 3
import Sortable from "sortablejs/modular/sortable.complete.esm";
import ApexCharts from 'apexcharts'
import ScrollBooster from "scrollbooster";
import { LineMaker } from './libs/line-maker';
import './flow-builder/index';




import Clipboard from "@ryangjchandler/alpine-clipboard"
import Splide from '@splidejs/splide';

import.meta.glob([
    // '../images/**',
    '../fonts/**',
]);



import tippy from "tippy.js";
// import 'tippy.js/dist/tippy.css';


import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || 'production',
    integrations: [
        Sentry.browserTracingIntegration({
            tracePropagationTargets: [
                /^https:\/\/(.*\.)?approvethis\.com/,
            ],
        }),
        Sentry.replayIntegration(),
        Sentry.browserProfilingIntegration(),
    ],
    // Performance
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.2'),
    // Profiling (relative to traces — requires Document-Policy: js-profiling header on server)
    profilesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || '0.1'),
    replaysOnErrorSampleRate: parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || '1.0'),
});

// Correlate JS errors to the logged-in account (set by layouts/app.blade.php).
if (window.__SENTRY_USER) {
    Sentry.setUser(window.__SENTRY_USER);
}

// Errors on billing surfaces block revenue — tag them so a Sentry alert rule
// can page on `surface:billing` instead of drowning in general JS noise.
if (window.location.pathname.startsWith('/billing')) {
    Sentry.setTag('surface', 'billing');
}


Alpine.plugin(Clipboard)
Alpine.plugin(ui);
// intersect is already included in Livewire 3, don't register it again


window.ApexCharts = ApexCharts;
window.Alpine = Alpine;
window.Splide = Splide;
window.Sortable = Sortable;
window.LineMaker = LineMaker;
window.ScrollBooster = ScrollBooster;
window.TomSelect = TomSelect;




document.addEventListener('alpine:init', () => {
    Alpine.data('docsSearch', docsSearch);

    // Embedded video review player (Gumlet / YouTube / Google Drive)
    Alpine.data('videoReviewPlayer', videoReviewPlayer);

    // E-Signature canvas component
    Alpine.data('eSignatureCanvas', () => ({
        mode: 'drawn',
        signaturePad: null,

        initCanvas() {
            const canvas = this.$refs.canvas;
            console.log('[esig] initCanvas called, canvas:', canvas, 'offsetWidth:', canvas?.offsetWidth, 'mode:', this.mode);

            if (!canvas) {
                console.log('[esig] no canvas ref found');
                return;
            }

            if (canvas.offsetWidth > 0) {
                console.log('[esig] canvas already visible, init immediately');
                this._initPad();
                return;
            }

            console.log('[esig] canvas has 0 width, setting up ResizeObserver');
            const observer = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    console.log('[esig] ResizeObserver fired, width:', entry.contentRect.width);
                    if (entry.contentRect.width > 0) {
                        observer.disconnect();
                        this._initPad();
                        return;
                    }
                }
            });
            observer.observe(canvas);
        },

        _initPad() {
            const canvas = this.$refs.canvas;
            console.log('[esig] _initPad called, canvas:', canvas, 'offsetWidth:', canvas?.offsetWidth, 'offsetHeight:', canvas?.offsetHeight);
            if (!canvas || canvas.offsetWidth === 0) {
                console.log('[esig] _initPad bailing — canvas missing or 0 width');
                return;
            }

            // HiDPI scaling
            const ratio = Math.max(window.devicePixelRatio || 1, 1);
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext('2d').scale(ratio, ratio);
            console.log('[esig] canvas sized to', canvas.width, 'x', canvas.height, 'ratio:', ratio);

            this.signaturePad = new SignaturePad(canvas, {
                backgroundColor: 'rgb(255,255,255)',
                penColor: 'rgb(30,41,59)',
            });
            console.log('[esig] SignaturePad created, isEmpty:', this.signaturePad.isEmpty());
        },

        clearCanvas() {
            this.signaturePad?.clear();
        },

        switchMode(newMode) {
            this.mode = newMode;
            if (newMode === 'drawn') {
                // Re-init pad after DOM shows canvas again
                this.$nextTick(() => this._initPad());
            }
        },

        _getDrawnSvg() {
            if (!this.signaturePad || this.signaturePad.isEmpty()) return '';
            return this.signaturePad.toSVG();
        },

        _getTypedSvg(name) {
            if (!name || !name.trim()) return '';
            const escaped = name.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
            return `<svg xmlns="http://www.w3.org/2000/svg" width="480" height="140" viewBox="0 0 480 140">` +
                `<style>@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&amp;display=swap');</style>` +
                `<rect width="480" height="140" fill="white"/>` +
                `<text x="240" y="90" font-family="Dancing Script, cursive" font-size="52" font-weight="600" ` +
                `fill="#1e293b" text-anchor="middle">${escaped}</text>` +
                `</svg>`;
        },

        submitSignature() {
            this.$wire.set('signatureType', this.mode);
            const svg = this.mode === 'drawn'
                ? this._getDrawnSvg()
                : this._getTypedSvg(this.$wire.get('signedName'));
            this.$wire.set('signatureSvg', svg);
            this.$wire.submit();
        },
    }));

    // Magic: $tooltip
    Alpine.magic('tooltip', el => message => {
        let instance = tippy(el, { content: message, trigger: 'manual' })

        instance.show()

        setTimeout(() => {
            instance.hide()

            setTimeout(() => instance.destroy(), 150)
        }, 2000)
    })

    // Directive: x-tooltip
    // Supports both string content and Filament's object format: { content: 'text', theme: 'light' }
    Alpine.directive('tooltip', (el, { expression }, { evaluate, effect, cleanup }) => {
        let instance = null

        effect(() => {
            const evaluated = evaluate(expression)

            // Handle both string and object formats (Filament passes { content, theme })
            let content = evaluated
            let theme = 'light-border'

            if (evaluated && typeof evaluated === 'object' && evaluated.content !== undefined) {
                content = evaluated.content
                theme = evaluated.theme === 'dark' ? 'dark' : 'light-border'
            }

            if (content && content !== 'false' && content !== false) {
                if (!instance) {
                    instance = tippy(el, {
                        content: content,
                        placement: 'top',
                        arrow: true,
                        theme: theme
                    })
                } else {
                    instance.setContent(content)
                }
            } else {
                if (instance) {
                    instance.destroy()
                    instance = null
                }
            }
        })

        // Proper cleanup when Alpine element is removed
        cleanup(() => {
            if (instance) {
                instance.destroy()
            }
        })
    })
})



Livewire.start() // This will also start Alpine automatically.


